import React from "react";
import { Typography } from "@mui/material";
import AudioPlayer from "./audioPlayer";

interface AudioShowActionProps {
  action_value?: any;
}

export default function AudioShowAction({ action_value }: AudioShowActionProps) {

  const sanitizeUrl = (url?: string) => {
    if (!url) return "";
    return url.replace(/&nbsp;/g, "").trim();
  };

  return (
    <>
      {action_value &&
        action_value.map((action: any, index: number) => {
          const audioSrc = sanitizeUrl(action.config_details.default_value);

          return (
            <div
              key={index}
              style={{ display: "flex", marginBottom: "10px", flexDirection: "column" }}
            >
              <Typography sx={{ fontWeight: "bold", marginRight: "20px" }}>
                {action.config_details.value.title} :
              </Typography>

              {audioSrc ? (
                <AudioPlayer
                  src={audioSrc}
                  showLoopControls={action.config_details?.value.is_trim === "true"}
                />
              ) : (
                <p>Audio not available.</p>
              )}
            </div>
          );
        })}
    </>
  );
}
